import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';

import Layout from './components/Layout';

import { BacktestCLIPage, BacktestCLIDiffusionPage, BacktestCLIInversePage, BacktestNovemberToAprilPage, BacktestLazyPortfolioPage } from './pages/backtest';
import { ExportChartByRegionPage, ExportSummaryNowPage, ExportSummaryNowRegionalPage, ExportSummaryPage, ExportSummaryRegionalPage, ExportVsStockPage } from './pages/trade';
import { KRXIdxEarningsPage, KRXIdxValuationBandPage, KRXIdxVsTradePage } from './pages/krx';
import { AllAssetPage, AllGlobalStockMarketPage, GoldDemandPage } from './pages/global';

import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ComingSoonPage from './pages/ComingSoonPage';
import UpdateSchedulePage from './pages/UpdateSchedulePage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>

          <Route index element={<HomePage />} />

          {/* Backtest */}
          <Route path="backtest/strategy-oecd-cli" element={<BacktestCLIPage />} />
          <Route path="backtest/strategy-inverse-oecd-cli" element={<BacktestCLIInversePage />} />
          <Route path="backtest/strategy-oecd-cli-di" element={<BacktestCLIDiffusionPage />} />
          <Route path="backtest/backtest-11to4" element={<BacktestNovemberToAprilPage />} />
          <Route path="backtest/backtest-lazy-portfolio" element={<BacktestLazyPortfolioPage />} />

          {/* Gold */}
          <Route path="global/gold_demand_trends" element={<GoldDemandPage />} />

          {/* Trade */}
          <Route path="kr-trade/export-summary-now" element={<ExportSummaryNowPage />} />
          <Route path="kr-trade/export-summary" element={<ExportSummaryPage />} />
          <Route path="kr-trade/stock-vs-export" element={<ExportVsStockPage />} />
          <Route path="kr-trade/export-summary-now_regional" element={<ExportSummaryNowRegionalPage />} />
          <Route path="kr-trade/export-summary-regional" element={<ExportSummaryRegionalPage />} />
          <Route path="kr-trade/export-by-region" element={<ExportChartByRegionPage />} />

          {/* KRX */}
          <Route path="krx-market/krx-idx-vs-trade" element={<KRXIdxVsTradePage />} />
          <Route path="krx-market/valuation" element={<KRXIdxValuationBandPage />} />
          <Route path="krx-market/earnings" element={<KRXIdxEarningsPage />} />
          <Route path="krx-market/stock-vs-earning" element={<ComingSoonPage title="주가 vs 어닝" />} />

          {/* Global */}
          <Route path="global/global-market-performance" element={<AllGlobalStockMarketPage />} />
          <Route path="global/all-asset-performance" element={<AllAssetPage />} />

          {/* Notice */}
          <Route path="notice/about" element={<AboutPage />} />
          <Route path="notice/updates" element={<UpdateSchedulePage />} />

          <Route path="*" element={<Navigate to="/" replace />} />

        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
